exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".dragArea{background-color:#292929;min-height:40px}img.dragLogo{max-height:40px;border-radius:0;max-width:500px;width:auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-811835d2","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/firmen/editFirmen_2.vue
// module id = 225
// module chunks = 0